import { graphql } from '@/generated';

export const allCustomers = graphql(`
  query allCustomers {
    customer(orderBy: { name: ASC }) {
      name
      id
    }
  }
`);

export const customerQuery = graphql(`
  query customer(
    $orderBy: [CustomerOrderBy!]!
    $where: CustomerBoolExp!
    $limit: Int!
    $offset: Int!
  ) {
    customer(orderBy: $orderBy, where: $where, limit: $limit, offset: $offset) {
      id
      name
      config
      sites {
        devicesAggregate {
          aggregate {
            count
          }
        }
      }
    }
    customerAggregate(where: $where) {
      aggregate {
        count
      }
    }
  }
`);

export const customerByPkQuery = graphql(`
  query customerByPk($id: uuid!) {
    customerByPk(id: $id) {
      id
      name
      storagePath
      config
      sites {
        id
        name
        devices {
          id
        }
      }
      apiKeys(orderBy: { createdAt: ASC }) {
        id
        key
        reference
        description
        roleId
      }
      sitesAggregate {
        aggregate {
          count
        }
      }
    }
  }
`);

export const devicesByIdsQuery = graphql(`
  query devicesByIds($ids: [uuid!]) {
    device(where: { id: { _in: $ids } }) {
      id
      shortId
      name
      serial
      site {
        name
        config
      }
      apiKeys(orderBy: { createdAt: ASC }) {
        key
        reference
        roleId
      }
    }
  }
`);

export const allRolesQuery = graphql(`
  query allRoles {
    aspNetRoles(orderBy: { name: ASC }) {
      id
      name
      normalizedName
    }
  }
`);
